import { map } from 'lodash';

import createResource from './createResource';
import { FileUpload } from './types';

const fileUploadsResource = createResource<FileUpload>({
  key: 'fileUploads',
  url: '/fileUploads',
  processStrategy: (data) => ({
    ...data,
    $allowedSquigglies: map(data.allowedSquigglies, (id) => `{{${id}}}`),
  }),
});

export default fileUploadsResource;
